package com.fireavert.auth.user_authentication.client.presentation

import com.fireavert.auth.user_authentication.client.PageAuthenticator

class PageAuthenticationController(
    private val pageAuthenticator: PageAuthenticator
) {

    suspend fun validatePageAccess(pageName: String): Boolean { return pageAuthenticator.validatePageAccess(pageName) }
}